const steps = [
  {
    num: "01",
    icon: "ri-phone-fill",
    title: "전화 · 문자 상담",
    desc: "010-2684-4892로 연락 주시면 즉시 전문 상담사가 상황을 확인합니다. 24시간 연중무휴 운영.",
    color: "bg-blue-500",
  },
  {
    num: "02",
    icon: "ri-car-fill",
    title: "신속 출동",
    desc: "상담 즉시 가장 가까운 전문 기술자가 출동합니다. 수도권 전지역 빠른 도착 보장.",
    color: "bg-blue-500",
  },
  {
    num: "03",
    icon: "ri-search-eye-fill",
    title: "정밀 누수 탐지",
    desc: "최신장비(가스탐지기, 청음기, 열화상카메라 등)로 정확한 누수 위치를 파악합니다.",
    color: "bg-blue-500",
  },
  {
    num: "04",
    icon: "ri-file-list-3-fill",
    title: "견적 안내",
    desc: "탐지 결과를 토대로 추가비용 없는 투명하고 정확한 견적을 제시해드립니다.",
    color: "bg-blue-500",
  },
  {
    num: "05",
    icon: "ri-tools-fill",
    title: "전문 시공",
    desc: "10년 이상의 경력 기술자가 최신 자재와 장비로 누수 원인을 근본적으로 해결합니다.",
    color: "bg-blue-500",
  },
  {
    num: "06",
    icon: "ri-shield-check-fill",
    title: "마무리 · AS 보장",
    desc: "완공 후 깔끔한 마무리와 함께 시공 보증서를 제공하고 무상 AS를 약속드립니다.",
    color: "bg-blue-500",
  },
];

export default function ProcessSection() {
  return (
    <section id="process" className="py-14 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 lg:px-6">
        <div className="text-center mb-10 lg:mb-16">
          <span className="inline-block text-blue-500 font-bold text-xs lg:text-sm tracking-widest uppercase mb-2 lg:mb-3">Process</span>
          <h2 className="text-2xl lg:text-4xl font-black text-zinc-900 mb-3 lg:mb-4">진행 절차</h2>
          <p className="text-zinc-500 text-sm lg:text-lg">
            연락부터 완공까지 <strong className="text-zinc-700">6단계</strong>로 신속하고 체계적으로 진행됩니다.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-8">
          {steps.map((step, idx) => (
            <div key={step.num} className="relative flex flex-col">
              <div className="bg-zinc-50 rounded-2xl p-5 lg:p-7 border border-zinc-100 hover:border-blue-200 transition-all duration-200 h-full">
                <div className="flex items-center gap-3 lg:gap-4 mb-3 lg:mb-4">
                  <div className="w-9 h-9 lg:w-12 lg:h-12 flex items-center justify-center bg-blue-500 text-white rounded-xl">
                    <i className={`${step.icon} text-base lg:text-xl`} />
                  </div>
                  <span className="text-3xl lg:text-4xl font-black text-blue-100">{step.num}</span>
                </div>
                <h3 className="text-zinc-900 font-bold text-base lg:text-lg mb-1.5 lg:mb-2">{step.title}</h3>
                <p className="text-zinc-500 text-xs lg:text-sm leading-relaxed">{step.desc}</p>
              </div>
              {/* Arrow connector */}
              {idx < steps.length - 1 && (
                <div className="hidden lg:flex absolute -right-4 top-1/2 -translate-y-1/2 z-10 w-8 h-8 items-center justify-center text-blue-400">
                  <i className="ri-arrow-right-line text-2xl" />
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Bottom highlight */}
        <div className="mt-10 lg:mt-14 text-center">
          <div className="inline-flex items-center gap-2 lg:gap-3 bg-blue-50 border border-blue-200 rounded-full px-5 lg:px-7 py-3 lg:py-4">
            <span className="w-4 h-4 lg:w-5 lg:h-5 flex items-center justify-center text-blue-500">
              <i className="ri-time-fill" />
            </span>
            <span className="text-zinc-700 text-sm lg:text-base font-semibold">평균 출동 시간 <strong className="text-blue-500">1시간 이내</strong> · 당일 처리 가능</span>
          </div>
        </div>
      </div>
    </section>
  );
}
